module.exports = __webpack_public_path__ + "static/media/MHRP25N0004.4fe7f13a.svg";